import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { Time } from '../../common/types'
import { messages } from './messages'

interface Props {
  time: Time | null
}

export const DisplayTime: React.FunctionComponent<Props> = ({ time }) => {
  const intl = useIntl()

  if (time) {
    return <DisplayTimeWrapper>{intl.formatMessage(messages.prefix, { time: time.toString() })}</DisplayTimeWrapper>
  }
  return null
}

const DisplayTimeWrapper = styled.div`
  padding: 0;
`
